import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Eye, EyeOff, Lock, CheckCircle2 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useScreenInit } from '../../useScreenInit';
export function CreatePassword() {
  useScreenInit();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, we'd check if this is a reset or new registration
    // For this flow, we'll assume it's part of registration and go to terms
    navigate('/terms');
  };
  const requirements = [{
    text: 'At least 8 characters',
    met: password.length >= 8
  }, {
    text: 'Contains a number',
    met: /\d/.test(password)
  }, {
    text: 'Contains a special character',
    met: /[!@#$%^&*]/.test(password)
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-78">
      <header className="px-4 py-4 flex items-center" data-id="element-79">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-80">
          <ChevronLeft className="w-6 h-6" data-id="element-81" />
        </button>
      </header>

      <main className="flex-1 px-6 py-4" data-id="element-82">
        <div className="mb-8" data-id="element-83">
          <h1 className="text-3xl font-heading font-bold text-text-primary mb-2" data-id="element-84">
            Create Password
          </h1>
          <p className="text-text-secondary leading-relaxed" data-id="element-85">
            Create a strong password to secure your FortuneBridge account.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-86">
          <div data-id="element-87">
            <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-88">
              New Password
            </label>
            <div className="relative" data-id="element-89">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-text-secondary" data-id="element-90">
                <Lock className="w-5 h-5" data-id="element-91" />
              </div>
              <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter new password" className="w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all outline-none text-text-primary" required data-id="element-92" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-4 flex items-center text-text-secondary hover:text-text-primary" data-id="element-93">
                {showPassword ? <EyeOff className="w-5 h-5" data-id="element-94" /> : <Eye className="w-5 h-5" data-id="element-95" />}
              </button>
            </div>
          </div>

          <div data-id="element-96">
            <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-97">
              Confirm Password
            </label>
            <div className="relative" data-id="element-98">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-text-secondary" data-id="element-99">
                <Lock className="w-5 h-5" data-id="element-100" />
              </div>
              <input type={showConfirm ? 'text' : 'password'} placeholder="Confirm new password" className="w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all outline-none text-text-primary" required data-id="element-101" />
              <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="absolute inset-y-0 right-0 pr-4 flex items-center text-text-secondary hover:text-text-primary" data-id="element-102">
                {showConfirm ? <EyeOff className="w-5 h-5" data-id="element-103" /> : <Eye className="w-5 h-5" data-id="element-104" />}
              </button>
            </div>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-105">
            <p className="text-sm font-semibold text-text-primary mb-3" data-id="element-106">
              Password Requirements:
            </p>
            <ul className="space-y-2" data-id="element-107">
              {requirements.map((req, idx) => <li key={idx} className="flex items-center text-sm" data-id="element-108">
                  <CheckCircle2 className={`w-4 h-4 mr-2 ${req.met ? 'text-brand-success' : 'text-gray-300'}`} data-id="element-109" />
                  <span className={req.met ? 'text-text-primary' : 'text-text-secondary'} data-id="element-110">
                    {req.text}
                  </span>
                </li>)}
            </ul>
          </div>

          <Button type="submit" fullWidth size="lg" data-id="element-111">
            Save Password
          </Button>
        </form>
      </main>
    </div>;
}